import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { withTUXIcon } from './withTUXIcon.js';
import * as React from 'react';

function IconTabArrowCounterClockwiseFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor"
  }, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    className: props.className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.05 22.89l2.36-2.18a1 1 0 011.41.06l1.35 1.45a1 1 0 01-.07 1.43l-5.74 5.15a2 2 0 01-2.77 0L3.3 23.62a1 1 0 01-.01-1.42l1.4-1.4a1 1 0 011.42 0l1.93 1.92a16 16 0 115.56 13.45.95.95 0 01-.04-1.4l1.39-1.43c.38-.4 1.01-.4 1.44-.05a12 12 0 10-4.35-10.4z"
  }));
}
var TUXIconTabArrowCounterClockwiseFill = withTUXIcon(IconTabArrowCounterClockwiseFill);

export default IconTabArrowCounterClockwiseFill;
export { TUXIconTabArrowCounterClockwiseFill };
